import actions from '../actions/actions';
import request from 'superagent';

function sendRequestTicket(store, action) {
    request
        .post('/t/api/salesforce/request')
        .send({
            companyName: action.payload,
        })
        .set('x-csrf-jwt', window.ha.csrfToken)
        // eslint-disable-next-line complexity
        .end((err, response) => {
            if (err) {
                store.dispatch(
                    actions.requestAccessFailure('ic.service.error.try.again')
                );
            } else {
                try {
                    const parsedResponse = JSON.parse(response.text);
                    window.ha.csrfToken = response.header['x-csrf-jwt'];
                    if (
                        parsedResponse &&
                        (parsedResponse.code >= 400 ||
                            parsedResponse.statusCode >= 400)
                    ) {
                        store.dispatch(
                            actions.requestAccessFailure(
                                'ic.service.error.try.again'
                            )
                        );
                    } else {
                        store.dispatch(
                            actions.requestAccessSucess(parsedResponse)
                        );
                    }
                } catch (e) {
                    store.dispatch(
                        actions.requestAccessFailure(
                            'ic.service.error.try.again'
                        )
                    );
                }
            }
            store.dispatch(actions.enableLoadOverlay(false));
        });
}

export {sendRequestTicket};
